import { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Centers content via the Tailwind `container` class: breakpoint max-widths,
 * auto side margins and .8rem padding (see tailwind.config.ts).
 *
 * GUARDRAIL: never let this wrap a full-height shell with an edge-docked
 * panel (wheel/positions/GEX right docks, the options-gpt chat sidebar) - the
 * auto margins push the dock off the viewport edge. Those routes must be
 * declared full-bleed in lib/dashboardShell.ts, which DashboardMainShell
 * resolves client-side per navigation. History: a stale server-side
 * x-pathname check kept re-wrapping the wheel dock after soft navigations.
 */
export default function MaxWidthWrapper({
  className,
  children,
  large = false,
}: {
  className?: string;
  large?: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "container",
        large ? "max-w-screen-2xl" : "max-w-6xl",
        className,
      )}
    >
      {children}
    </div>
  );
}
